import classNames from 'classnames/bind';
import React, { useMemo, useState } from 'react';
import { RiDeleteBinLine } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';

import styles from './index.module.scss';

import actions from '@/actions';
import Bar from '@/components/ui/Bar';
import EmptyList from '@/components/ui/EmptyList';
import { IconButton } from '@/components/ui/kit/Button';
import Select from '@/components/ui/kit/Select';

const cx = classNames.bind(styles);

const Notifications = () => {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notifications);
  const robots = useSelector((state) => state.robots);
  const [selectedRobotId, setSelectedRobotId] = useState('all');

  const notificationsWithRobots = useMemo(() => {
    return notifications.map((notification) => ({
      ...notification,
      robot: robots.find((robot) => robot.id === notification.robotId),
    }));
  }, [notifications, robots]);

  const filtered = useMemo(() => {
    // 선택된 로봇이 없으면 전체 반환
    if (selectedRobotId === 'all') return notificationsWithRobots;

    return notificationsWithRobots.filter(({ robotId }) => robotId === selectedRobotId);
  }, [notificationsWithRobots, selectedRobotId]);

  const selectFilter = (e) => {
    setSelectedRobotId(e.target.value);
  };

  const removeAll = () => {
    dispatch(actions.notifications.reset());
  };

  return (
    <div className={cx('container')}>
      <div className={cx('header')}>
        <div className={cx('title')}>Notifications</div>
        <div className={cx('right')}>
          <Select name="robot" value={selectedRobotId} onChange={selectFilter} className={cx('filter')} align="right">
            <option value="all">All</option>
            {robots
              .filter((robot) => robot.isActive)
              .map((robot) => (
                <option key={robot.id} value={robot.id}>
                  {robot.name}
                </option>
              ))}
          </Select>
          <IconButton type="mini" onClick={removeAll} Icon={RiDeleteBinLine} />
        </div>
      </div>
      <div className={cx('list')}>
        {filtered.length === 0 && (
          <div className={cx('empty')}>
            <EmptyList message="No items" />
          </div>
        )}
        {filtered.map((notification) => (
          <div key={notification.id} className={cx('row')}>
            <div className={cx('robot')}>
              <div className={cx('color')} style={{ backgroundColor: notification.robot.color }} />
              <div className={cx('name')}>{notification.robot.name}</div>
            </div>
            <Bar />
            <div className={cx('text')}>{notification.text}</div>
            <div className={cx('time')}>{notification.time}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Notifications;
